import { dataVideoAdd } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoAdd = /*#__PURE__*/createIcon(dataVideoAdd)
export default IconVideoAdd
